import * as React from 'react';
import TFFTypography from '../../styled-components/TFFTypography';
import { useBookingContext } from '../../hooks/use-booking-context';

interface AdditionalPriceRowProps {
  text: string;
  value: number;
}

const AdditionalPriceRow: React.FC<AdditionalPriceRowProps> = ({ text, value }) => {
  const { numberFormatter } = useBookingContext();

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
      <TFFTypography text={text} />
      <TFFTypography text={numberFormatter.format(value)} />
    </div>
  );
};

export default AdditionalPriceRow;
